import {
  addHtmlElementEventListener,
  appendHtmlElementChild,
  enableHtmlElement,
  getHtmlElement,
  removeHtmlChildren,
  renderWebComponent,
  string2obj
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import { submissionListFulfillmentPDF } from "../../../utils/PDFGEnerator/submissionListFulfillTemplate";
import I18n from "i18n-js";
import { submissionListPDF } from "../../../utils/PDFGEnerator/submissionListTemplate";


export class PdfGeneratorComponent extends HTMLElement {
  props = {};

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
  }

  connectedCallback() {
    addHtmlElementEventListener(this.shadowRoot, 'printButton', 'click', () => this.props.useTemplate === 'submissionListShipmentLabel' ? this.printPDFFile() : this.getDataToPrintOnPDFFile())
  }


  // Funzione che aggiorna il layout del bottone di download del pdf quando parte il download vero e proprio dei dati
  startLoadingData() {
    enableHtmlElement(this.shadowRoot, 'printButton', false);
    removeHtmlChildren(getHtmlElement(this.shadowRoot, 'printButton'));

    const row = document.createElement('template');
    row.innerHTML = `
      <div class="d-flex align-items-center text-center">
        <div class="spinner-border text-white ml-2" role="status"></div>
        <p class="ml-2 text-nowrap text-white mb-0">
          ${I18n.t('js.PDFGenerator.submissionList.loadingData').toUpperCase()}
        </p>
      </div>
    `

    appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'printButton'), row.content.cloneNode(true));
  }


  // Funzione che aggiorna il layout del bottone di download del pdf quando termina il download dei dati
  endLoadingData() {
    enableHtmlElement(this.shadowRoot, 'printButton', true);
    removeHtmlChildren(getHtmlElement(this.shadowRoot, 'printButton'));

    const row = document.createElement('template');
    row.innerHTML = `
      ${
        this.props.displayDownloadIcon ?
          `<img src="/images/icons/white/download-pdf.svg"
               alt="" width="30" height="30"
               class="mr-1"
          >
            ${this.props.generatorText}`
        :
          `${this.props.generatorText}`
      }
    `

    appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'printButton'), row.content.cloneNode(true));
  }


  // Funzione che permette di ottenere dal server il dettaglio completo e aggiornato dei dati
  // che devono essere stampati su pdf
  getDataToPrintOnPDFFile = () => {
    if (this.props.displayDownloadIcon || this.props.displaySpinner)
      this.startLoadingData();

    if (this.props.useTemplate.indexOf('submissionList') > -1) {
      let url = `/submission_lists/${this.props.dataToPrint.submissionListInfo.id}.json`

      if (this.props.environment === 'backoffice')
        url = url + '?request_from=backoffice'

      fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        }
      })
        .then((res) => {
          if (!res.ok)
            throw Error("An error occour during getting data from database");
          else
            return res.json()
        })
        .then((data) => {
          submissionListPDF(data, this.props.environment)
          if (this.props.displayDownloadIcon || this.props.displaySpinner)
            this.endLoadingData();
        })
        .catch((error) => {
          if (this.props.displayDownloadIcon || this.props.displaySpinner)
            this.endLoadingData();
        });

    }
  }



  // Funzione che genera il pdf stampandoci direttamente i dati senza chiederli al server
  printPDFFile() {
    if (this.props.useTemplate === 'submissionListShipmentLabel')
      submissionListFulfillmentPDF(this.props.dataToPrint);
  }



  render() {
    const html = `              
      ${
        this.props.type === 'button' ?
          `
            <button
              type="button"
              id="printButton"
              class="${this.props.cssClassList}"
            >
              ${
                this.props.displayDownloadIcon ? 
                  `<img src="/images/icons/white/download-pdf.svg" 
                    alt="" width="25" height="25"
                    class="mr-1"
                  >`
                :
                  ``
              }
              ${this.props.generatorText}
            </button>
          `
        :
          `<span class="text-aiBlue text-underline-imp cursor-pointer" >
            ${this.props.generatorText}
          </span>`
      }
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles]);
  }
}

window.customElements.define("pdf-generator-component", PdfGeneratorComponent);